import View from '@modul-connect/shared/components/atoms/view'
import { P } from '@modul-connect/shared/components/atoms/text'
import theme from '@modul-connect/shared/theme'

const textStyle = {
  fontFamily: theme.layout.fontFamily,
  fontStyle: 'normal',
  fontWeight: 400,
  fontSize: 12,
  lineHeight: '15px',
  color: theme.colors.black,
  margin: 0
}

const subheadingStyle = {
  fontFamily: theme.layout.fontFamily,
  fontWeight: 400,
  fontSize: 16,
  lineHeight: '19px',
  color: theme.colors.black,
  margin: 0,
}

const IMAGE_WIDTH = 233
const IMAGE_HEIGHT = 128

const ImageWithCaption = ({ image, caption }) => {
  if (image == null) return null
  return (
    <View style={{ display: 'flex', flexDirection: 'column', gap: 8, width: IMAGE_WIDTH }}>
      <View
        style={{
          width: IMAGE_WIDTH,
          height: IMAGE_HEIGHT,
          borderRadius: 8,
          overflow: 'hidden',
        }}
      >
        {typeof image === 'string' ? (
          <img src={image} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
        ) : (
          image
        )}
      </View>
      {caption && <P style={textStyle}>{caption}</P>}
    </View>
  )
}

export const BatteryGuideContent = ({
  introText,
  batteryType,
  batteryTypeText,
  footnote,
  subHeading,
  image1,
  caption1,
  image2,
  caption2,
  image3,
  caption3,
  image4,
  caption4,
  subHeading2,
  batteryTypeText2
}) => {
 
  const hasExtendedContent = image3 || image4
  return (
    <View style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 16, overflowX: 'hidden', padding: '32px 24px', maxHeight: hasExtendedContent ? 460 : 'none', overflowY: hasExtendedContent ? 'auto' : 'visible' }}>

      <View style={{padding: 0, width: '100%' }}>
        {introText && <P style={textStyle}>{introText}</P>}
      </View>
      <View style={{ width: '100%', height: 0, borderTop: `0.5px solid ${theme.colors.simpleButtonBorder}`, alignSelf: 'stretch' }} />

      <View style={{ display: 'flex', flexDirection: 'column', gap: 16, width: '100%' }}>
    
        <View style={{ display: 'flex', flexDirection: 'column', padding: 0, gap: 12 }}>
          <P style={subheadingStyle}>{subHeading}</P>
          <View style={{ display: 'flex', flexDirection: 'row', gap: 4, alignItems: 'center' }}>
            {batteryType && <P style={textStyle}>{batteryType}</P>}
            {batteryTypeText && <P style={{ ...textStyle, fontWeight: 700 }}>{batteryTypeText}</P>}
          </View>
          {footnote && <P style={{ ...textStyle, fontWeight: 700, fontStyle: 'italic' }}>{footnote}</P>}
        </View>


        <View style={{ display: 'flex', flexDirection: 'row', gap: 16 }}>
          <ImageWithCaption image={image1} caption={caption1} />
          <ImageWithCaption image={image2} caption={caption2} />
        </View>

        {(image3 || image4) && (
          <>
            <View style={{ width: '100%', height: 0, borderTop: `0.5px solid ${theme.colors.simpleButtonBorder}`, alignSelf: 'stretch', margin: '20px 0' }} />
            {subHeading2 && (
              <View style={{ display: 'flex', flexDirection: 'column', padding: 0, gap: 12}}>
                <P style={subheadingStyle}>{subHeading2}</P>
                <View style={{ display: 'flex', flexDirection: 'row', gap: 4, alignItems: 'center' }}>
                  {batteryType && <P style={textStyle}>{batteryType}</P>}
                  {batteryTypeText && <P style={{ ...textStyle, fontWeight: 700 }}>{batteryTypeText2}</P>}
                </View>
                {footnote && <P style={{ ...textStyle, fontWeight: 700, fontStyle: 'italic' }}>{footnote}</P>}
              </View>

            )}
            <View style={{ display: 'flex', flexDirection: 'row', gap: 16 }}>
              <ImageWithCaption image={image3} caption={caption3} />
              <ImageWithCaption image={image4} caption={caption4} />
            </View>
          </>
        )}
      </View>
      
    </View>
  )
}
